import { useState, useCallback } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import ContentSection from "./components/ContentSection";
import InterestForm from "./components/InterestForm";
import Footer from "./components/Footer";
import QuickButtons from "./components/QuickButtons";
import FloatingForm from "./components/FloatingForm";
import DailyPopup from "./components/DailyPopup";

export default function Home() {
  const [floatingFormOpen, setFloatingFormOpen] = useState(false);

  const openFloatingForm = useCallback(() => {
    setFloatingFormOpen(true);
    document.body.style.overflow = "hidden";
  }, []);

  const closeFloatingForm = useCallback(() => {
    setFloatingFormOpen(false);
    document.body.style.overflow = "";
  }, []);

  return (
    <div className="relative w-full min-h-screen bg-background-50">
      {/* Header */}
      <Header onOpenForm={openFloatingForm} />

      {/* Hero Section */}
      <Hero />

      {/* Content Images Section */}
      <ContentSection />

      {/* Interest Registration Form */}
      <section id="interest-form-section" className="w-full">
        <InterestForm />
      </section>

      {/* Footer */}
      <Footer />

      {/* Quick Action Buttons */}
      <QuickButtons onOpenForm={openFloatingForm} />

      {/* Floating Registration Form Popup */}
      <FloatingForm isOpen={floatingFormOpen} onClose={closeFloatingForm} />

      {/* Daily Popup */}
      <DailyPopup />

      {/* Mobile bottom bar spacer */}
      <div className="md:hidden h-16" />
    </div>
  );
}